import _ from "lodash";

export const searchCurrentOfferHasCandidature = (candidature, offerId) => {
  const offers = _.get(candidature, 'offer_has_candidatures')
  let offer = _.filter(offers, { offer: {id: offerId }})
  if (_.isEmpty(offer)) {
    return false
  }
  return offer[0]
}